/* Native Shopify cart contracts. No browser-local commerce or payment simulation. */
(() => {
  'use strict';
  const config = JSON.parse(document.querySelector('#liotro-data').textContent);
  const base = new URL(config.root, location.origin);
  if (base.origin !== location.origin) throw new Error('Invalid storefront route');
  const queue = {tail: Promise.resolve()};
  const endpoint = name => new URL(`cart/${name}.js`, base).pathname;
  async function json(url, options = {}) {
    const response = await fetch(url, {credentials:'same-origin', ...options, headers:{Accept:'application/json', ...options.headers}});
    let data;
    try { data = await response.json(); } catch { throw new Error(window.LiotroText('liotro.content.la_risposta_del_carrello_non_e_disponi_617b84')); }
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || window.LiotroText('liotro.content.non_e_stato_possibile_aggiornare_il_ca_7dca88'));
    return data;
  }
  function serial(action) {
    const result = queue.tail.then(action);
    queue.tail = result.catch(() => {});
    return result;
  }
  const sectionFields = () => {
    const cartSection=document.querySelector('[data-liotro-cart-section-id]')?.getAttribute('data-liotro-cart-section-id');
    return {sections:['liotro-cart-drawer',...(cartSection?[cartSection]:[])],sections_url:new URL(config.cartURL,location.origin).pathname};
  };
  async function changed(result) {
    const state = await json(new URL('cart.js', base).pathname);
    document.dispatchEvent(new CustomEvent('liotro:cart-updated', {detail:{cart:state, sections:result.sections || {}}}));
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:state}}));
    return {cart:state, sections:result.sections || {}};
  }
  window.LiotroCommerce = {
    setPaused: paused => {if(typeof paused!=='boolean')throw Error('Invalid purchase state');config.paused=paused;},
    read: () => json(new URL('cart.js', base).pathname),
    add(input) {
      return serial(async () => {
        if (config.paused) throw new Error(window.LiotroText('liotro.content.gli_acquisti_sono_momentaneamente_sosp_0f6b00'));
        const data = input instanceof FormData ? input : Object.assign({}, input);
        let options;
        if (data instanceof FormData) {
          // Includes variant, quantity, app properties, uploads, selling plan and recipient fields.
          data.delete('sections'); data.delete('sections_url');
          const fields=sectionFields();data.set('sections',fields.sections.join(','));data.set('sections_url',fields.sections_url);
          options = {method:'POST', body:data};
        } else {
          options = {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...data,...sectionFields()})};
        }
        return changed(await json(endpoint('add'), options));
      });
    },
    change(key, quantity) {
      return serial(async () => {
        if (!Number.isInteger(quantity) || quantity < 0) throw new Error(window.LiotroText('liotro.content.controlla_la_quantita_dda041'));
        return changed(await json(endpoint('change'), {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity,...sectionFields()})}));
      });
    },
    update(values,{renderSections=true}={}) {
      return serial(async () => changed(await json(endpoint('update'), {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...values,...(renderSections?sectionFields():{})})})));
    }
    ,clear(){return serial(async()=>changed(await json(endpoint('clear'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(sectionFields())})));}
  };
})();
